<template>
  <v-container class="gsignin">
    <v-layout justify-center align-content-space-around>
      <v-flex lg7 md7 sm8 xs12>
        <div class="container container-table">
            <!-- login Button -->
            <button id="gsignin-button" @click="signInGoogle" @mouseout="btnHasFocus = false;" @mouseover="btnHasFocus = true;">
              <v-img v-if="!btnHasFocus" src='~@/assets/auth/btn_google_signin_light_normal_web@2x.png' alt="Sign in with Google" width="200" position="top left" contain></v-img>
              <v-img v-if="btnHasFocus" src='~@/assets/auth/btn_google_signin_light_pressed_web@2x.png' alt="Sign in with Google" width="200" position="top left" contain></v-img>
            </button>
            <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
          </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      context: 'oauth2 context',
      code: this.$route.query.code,
      btnHasFocus: false
    };
  },
  methods: {
    signInGoogle() {
      this.btnHasFocus = true;
      this.$auth.oauth2({
        provider: 'google',
        rememberMe: true,
        params: {
          // Any key/value pairs will be appended to url.
        }
      });
    }
  },
  mounted() {
    if (this.$route.query.code) {
      // successful google login, now get user's token
      this.loading = true;
      this.$auth.oauth2({
        code: true,
        provider: 'google',
        params: {
          code: this.code
        },
        success(res) {
          console.log('success ' + this.context);
          this.loading = false;
        },
        error(res) {
          console.log('error ' + this.context);
          this.loading = false;
        },
        redirect: { path: '/dashboard' }
      });
    }
  }
};
</script>
